import React from "react";
import Modal from "react-modal";
import SignUp from "./sign-up.jsx";
import SaveSearch from "./save-search.jsx";

export default function Popup(props) {
    Modal.setAppElement("body");

    return (
        <Modal isOpen={true}
            className="save-search-popup-content"
            overlayClassName="save-search-popup-overlay"
            onRequestClose={props.onRequestClose}>

            <a className="save-search-popup-close" onClick={props.onRequestClose} />

            {props.isAuthenticated ? <SaveSearch {...props} /> : <SignUp {...props} />}
        </Modal>
    );
}